import { c as _c } from "react/compiler-runtime";
import { clsx } from 'clsx';
import styles from './Divider.module.css';
import type { DividerProps } from './Divider.types';
const Divider = t0 => {
  const $ = _c(7);
  const {
    variant,
    className
  } = t0;
  const t1 = variant === "vertical";
  const t2 = variant === "horizontal";
  let t3;
  if ($[0] !== className || $[1] !== t1 || $[2] !== t2) {
    t3 = clsx(styles.divider, {
      [styles.dividerVertical]: t1,
      [styles.dividerHorizontal]: t2
    }, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const dividerStyles = t3;
  let t4;
  if ($[4] !== dividerStyles || $[5] !== variant) {
    t4 = <div data-test-id="Divider" className={dividerStyles} role="separator" aria-orientation={variant} />;
    $[4] = dividerStyles;
    $[5] = variant;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export { Divider };